import { LossTypes } from "@/models/tpp-claims/LossTypes";
import { TPPClaimsState } from "@/models/store/TPPClaimsState";

export const additionalInfoMutations = {
  setPropertyManagerNotified: (state: TPPClaimsState, propertyManagerNotified: boolean) => {
    state.selectedTPPClaim!.info_manager_notified = propertyManagerNotified;
  },
  setDiscoveredLoss: (state: TPPClaimsState, discoveredLoss: string) => {
    state.selectedTPPClaim!.damage_discovered_by = discoveredLoss;
  },
  setCurrentLocationDamagedItems: (state: TPPClaimsState, currentLocation: string) => {
    state.selectedTPPClaim!.items_current_location = currentLocation;
  },
  setFiledOtherClaim: (state: TPPClaimsState, filedOtherClaim: boolean) => {
    state.selectedTPPClaim!.another_claim_filed = filedOtherClaim;
  },
  setFiledOtherClaimLossType: (state: TPPClaimsState, lossType: LossTypes) => {
    state.selectedTPPClaim!.another_claim_loss_type = lossType;
  },
  setFiledOtherClaimDate: (state: TPPClaimsState, claimDate: string) => {
    state.selectedTPPClaim!.another_claim_date = claimDate;
  }
};
